import { RoleType } from '../db-entries/index.js';
/** The role type to i18n key mapping. */
export const roleTypeToKey = Object.freeze({
    [RoleType.User]: 'user',
    [RoleType.MachineToMachine]: 'machine_to_machine',
});
